import React from "react";
import Drawer from "react-bottom-drawer";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var startY = 0;
var startScrollTop = 0;
var GenericDrawer = function (props) {
    var device = DeviceContext();
    // React.useEffect(() => {
    //   if (props.show) {
    //     di.footer.updateShowMob_Menu(false);
    //     di.header.RemoveHeaderData(false);
    //   } else {
    //     //di.footer.updateShowMob_Menu(true);
    //     di.header.RemoveHeaderData(true);
    //   }
    // }, [props.show]);
    React.useEffect(function () {
        var element = document.getElementById("ymPluginDivContainerInitial");
        if (element && (props === null || props === void 0 ? void 0 : props.show) && (device === null || device === void 0 ? void 0 : device.isMobile)) {
            element.style.zIndex = "0";
        }
        return function () {
            if (element) {
                element.style.zIndex = "999";
            }
        };
    }, [props === null || props === void 0 ? void 0 : props.show]);
    var callBackRef = function (node) {
        if (node) {
            var commondrawerscroll_1 = node.getElementsByClassName("common-drawer-scroll")[0];
            var handleTouchStart = function (e) {
                var touch = e.touches[0];
                startY = touch.clientY;
                startScrollTop = commondrawerscroll_1 === null || commondrawerscroll_1 === void 0 ? void 0 : commondrawerscroll_1.scrollTop;
            };
            var handleTouchMove = function (e) {
                var touch = e.touches[0];
                var deltaY = startY - touch.clientY;
                var newScrollTop = startScrollTop + deltaY;
                if (newScrollTop <= 0) {
                    commondrawerscroll_1.scrollTop = 0;
                }
                else {
                    commondrawerscroll_1.scrollTop = newScrollTop;
                }
            };
            commondrawerscroll_1 === null || commondrawerscroll_1 === void 0 ? void 0 : commondrawerscroll_1.addEventListener("touchstart", handleTouchStart);
            commondrawerscroll_1 === null || commondrawerscroll_1 === void 0 ? void 0 : commondrawerscroll_1.addEventListener("touchmove", handleTouchMove);
        }
    };
    return (React.createElement(Drawer, { className: "backgroundcolor_bluedrawer px-0 ".concat(props.parentClass), hideScrollbars: true, isVisible: props.show, onClose: function () { return props.setShow(); } },
        React.createElement("div", { className: "drawer-head ".concat(props.headerClassName) }, props.headerComp),
        React.createElement("div", { className: "drawer-body bg_white", ref: callBackRef }, props.bodyComp)));
};
export default GenericDrawer;
